import { render, staticRenderFns } from "./panoramicAlone.vue?vue&type=template&id=4f5cfc0a&scoped=true"
import script from "./panoramicAlone.vue?vue&type=script&lang=js"
export * from "./panoramicAlone.vue?vue&type=script&lang=js"
import style0 from "./panoramicAlone.vue?vue&type=style&index=0&id=4f5cfc0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cfc0a",
  null
  
)

export default component.exports